import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./components/pages/Login";
import {
  PrivateRoutes,
  PublicRoutes,
  PublicRoutes2,
  PublicRoutes3,
} from "./utilities/PrivateRoutes";
import { Provider } from "react-redux";
import { newStore } from "@mywvglobal-shared/mywv-shared/store";
import storage from "redux-persist/lib/storage";
import { AlertProvider } from "./context/AlertContext";
import { PageLoaderNew } from "./components/atoms/Loader";
import "primeicons/primeicons.css";
import Home from "./components/pages/Home";
import { useTranslation } from "react-i18next";
import GlobalFont from "./components/molecule/GlobalFont";
import { Helmet } from "react-helmet";
const CommunityHomeView = React.lazy(() =>
  import("./components/pages/CommunityHomeView")
);
const DroppedChildProfile = React.lazy(() =>
  import("./components/pages/DroppedChildProfile")
);
const GetHelp = React.lazy(() => import("./components/pages/GetHelp"));
const ChoosenLayout = React.lazy(() =>
  import("./components/pages/ChoosenLayout")
);
const SignleChosenSponsorChild = React.lazy(() =>
  import("./components/pages/SingleChosenSponsorChild")
);
const AccountView = React.lazy(() => import("./components/pages/AccountView"));
const OpenCommunityStation = React.lazy(() =>
  import("./components/pages/OpenCommunityStation")
);
const ProjectCelebration = React.lazy(() =>
  import("./components/pages/ProjectCelebration")
);
const OpenChildStation = React.lazy(() =>
  import("./components/pages/openChildStation")
);
const OpenStation = React.lazy(() => import("./components/pages/OpenStation"));
const SendAGift = React.lazy(() => import("./components/pages/SendAGift"));
const Donate = React.lazy(() => import("./components/pages/Donate"));
const OpenConnectView = React.lazy(() =>
  import("./components/pages/OpenConnectView")
);
const NewsAndStories = React.lazy(() =>
  import("./components/pages/NewsAndStories")
);
const PageNotFound = React.lazy(() =>
  import("./components/pages/PageNotFound")
);
const PastSponsoredChildView = React.lazy(() =>
  import("./components/pages/PastSponsoredChildView")
);
const { store } = newStore(storage);

function App() {
  const { t } = useTranslation();

  // Defensive code to prevent clickjacking (frame busting)
  React.useEffect(() => {
    if (window.top !== window.self) {
      window.top.location = window.self.location;
    }
  }, []);
  const csp = [
  "default-src 'self'",
  "script-src 'self' 'unsafe-inline' https://www.googletagmanager.com https://www.google-analytics.com https://maps.googleapis.com https://maps.gstatic.com https://static.hotjar.com https://script.hotjar.com",
  "object-src 'none'",
  "connect-src 'self' https://qa-common.wvmobile.org https://dev-useast1.wvmobile.org https://stg-common.wvmobile.org https://prod-useast1.wvmobile.org https://stg-wvjpn.wvmobile.org https://qa-wvautfin.wvmobile.org https://fino-uat-wvi-ciam.onelogin.com https://jpno-uat-wvi-ciam.onelogin.com https://auto-uat-wvi-ciam.onelogin.com https://cdnjs.cloudflare.com https://maps.googleapis.com https://www.google-analytics.com https://wvnz-dev.au.auth0.com https://account-dev.worldvision.org.nz wss://ws.hotjar.com https://content.hotjar.io",
  "style-src 'self' 'unsafe-inline' https://cdnjs.cloudflare.com https://fonts.googleapis.com https://cdn.jsdelivr.net",
  "style-src-elem 'self' 'unsafe-inline' https://cdnjs.cloudflare.com https://fonts.googleapis.com https://cdn.jsdelivr.net",
  "font-src 'self' https://fonts.gstatic.com https://cdn.jsdelivr.net",
  "frame-src 'self' https://wvnz-dev.au.auth0.com https://jpno-uat-wvi-ciam.onelogin.com https://*.cloudfront.net https://account-dev.worldvision.org.nz",
  "img-src * data: blob:",
  "media-src 'self' https://*.cloudfront.net"
].join("; "); 
  return (
    <Provider store={store}>
      <AlertProvider>
      <Helmet>
        <meta httpEquiv="Content-Security-Policy" content={csp} />
        <meta httpEquiv="Strict-Transport-Security" content="max-age=31536000; includeSubDomains; preload" />
        <meta httpEquiv="X-Content-Type-Options" content="nosniff" />
        <meta httpEquiv="X-XSS-Protection" content="1; mode=block" />
      </Helmet>
        <GlobalFont></GlobalFont>
        <Suspense
          fallback={
            <PageLoaderNew fulldiv>
              <div className="spinner--wv-star">
                <div className="double-bounce1"></div>
                <div className="double-bounce2"></div>
              </div>
              <span className="loader_text">{t("Pleasewait")}</span>
            </PageLoaderNew>
          }
        >
          <BrowserRouter basename="/WVRetentionPortal/">
            <Routes>
              <Route element={<PublicRoutes />}>
                <Route exact="true" path="/" element={<Login />} />
              </Route>
              <Route element={<PublicRoutes2 />}>
                <Route exact="true" path="/:soname" element={<Login />} />
              </Route>
              <Route element={<PublicRoutes3 />}>
                <Route path="/getHelp" element={<GetHelp />} />
              </Route>
              <Route element={<PrivateRoutes />}>
                <Route path="/chosen-layout/:id" element={<ChoosenLayout />} />
              </Route>
              <Route element={<PrivateRoutes />}>
                <Route
                  path="/chosen-children/"
                  element={<SignleChosenSponsorChild />}
                />
              </Route>
              <Route element={<PrivateRoutes home />}>
                <Route path="/home" element={<Home />} />
              </Route>
              <Route element={<PrivateRoutes home />}>
                <Route
                  path="/project-celebration/:childcode"
                  element={<ProjectCelebration />}
                />
              </Route>
              <Route element={<PrivateRoutes />}>
                <Route
                  path="drop-child-profile/:childcode"
                  element={<DroppedChildProfile />}
                />
                <Route
                  path="/communityhomeview/:childcode"
                  element={<CommunityHomeView />}
                />
                <Route element={<OpenStation />}>
                  <Route path="/community/station/:childcode/:stationid/" />
                  <Route path="/community/station/:childcode/:stationid/OurProgress" />
                  <Route path="/community/station/:childcode/:stationid/ExploreStories" />
                </Route>
                <Route
                  path="/community/childprofile/:childcode/:stationid"
                  element={<OpenChildStation />}
                ></Route>
                <Route path="/community/childprofile/:childcode/:stationid/MyProgress" />
                <Route path="/community/childprofile/:childcode/:stationid/AboutMe" />
                <Route path="/community/childprofile/:childcode/:stationid/MyDailyLife" />
                <Route path="/community/childprofile/:childcode/:stationid/HowIGrown" />
                {/* </Route> */}
                <Route element={<PastSponsoredChildView />}>
                  <Route path="/community/pastSponsoredChild/:pastchildcode" />
                  <Route path="/community/pastSponsoredChild/:pastchildcode/HowIGrown" />
                </Route>
                <Route element={<OpenCommunityStation />}>
                  <Route path="/community/childcommunity/:childcode/:stationid" />
                  <Route path="/community/childcommunity/:childcode/:stationid/OurProgress" />
                  <Route path="/community/childcommunity/:childcode/:stationid/AboutCommunity" />
                  <Route path="/community/childcommunity/:childcode/:stationid/AboutCountry" />
                  <Route path="/community/childcommunity/:childcode/:stationid/LifeandCulture" />
                  <Route path="/community/childcommunity/:childcode/:stationid/MediaGallery" />
                </Route>
                <Route element={<AccountView />}>
                  <Route path="/myaccount" />
                  <Route path="/notification" />
                  <Route path="/sponsorships" />
                  <Route path="/donations" />
                  <Route path="/security" />
                </Route>
                <Route element={<OpenConnectView />}>
                  <Route path="/connect/:childcode" />
                  <Route path="/connect/:childcode/WriteAmessage" />
                  <Route path="/connect/:childcode/LetterJourney" />
                  <Route path="/connect/:childcode/FAQs" />
                  <Route path="/connect/:childcode/TipsForWriting" />
                </Route>

                <Route element={<Donate />}>
                  <Route path="/sendAGift/:childcode" />
                </Route>
                <Route path="/donate" element={<SendAGift />} />
                <Route path="/newsandstories" element={<NewsAndStories />} />
                <Route path="/PageNotFound" element={<PageNotFound />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </Suspense>
      </AlertProvider>
    </Provider>
  );
}

export default App;
